module.exports = __webpack_public_path__ + "img/ta_askfor_result-qrimg.a802f180.jpg";